import { createReducer, on } from '@ngrx/store';
import { initialState, PasswordRecoverStatus, PasswordResetStatus, PasswordState } from './password.state';
import { passwordActions } from './password.actions';

export const passwordReducer = createReducer(
  initialState,
  on(passwordActions.recover_password_page_open, (state): PasswordState => {
    return {
      ...state,
      recoverStatus: PasswordRecoverStatus.EmailInput,
      recoverEmail: null
    };
  }),
  on(passwordActions.recover_password_request_start, (state, action): PasswordState => {
    return {
      ...state,
      recoverStatus: PasswordRecoverStatus.SendingLink,
      recoverEmail: action.email
    };
  }),
  on(passwordActions.recover_password_request_success, (state): PasswordState => {
    return {
      ...state,
      recoverStatus: PasswordRecoverStatus.LinkSent
    };
  }),
  on(passwordActions.recover_password_request_failure, (state): PasswordState => {
    return {
      ...state,
      recoverStatus: PasswordRecoverStatus.LinkSent
    };
  }),
  on(passwordActions.reset_password_request_start, (state): PasswordState => {
    return {
      ...state,
      reset: {
        ...state.reset,
        status: PasswordResetStatus.Resetting
      }
    };
  }),
  on(passwordActions.reset_password_request_success, (state): PasswordState => {
    return {
      ...state,
      reset: {
        ...state.reset,
        status: PasswordResetStatus.Success
      }
    };
  }),
  on(passwordActions.reset_password_request_failure, (state): PasswordState => {
    return {
      ...state,
      reset: {
        ...state.reset,
        status: PasswordResetStatus.Failed
      }
    };
  })
);
